export const API_PATH_TEMPORARY_PASSWORD = '/temporary-password';
export const API_PATH_REGISTRATION = '/registration';
export const API_PATH_LOGIN_BY_TEMPORARY_PASSWORD = '/login-by-temporary-password';
export const API_SEND_VERIFICATION_EMAIL = '/verification-email';

export const API_PATHS_WITHOUT_CREDENTIALS = [
    API_PATH_TEMPORARY_PASSWORD,
    API_PATH_REGISTRATION,
    API_PATH_LOGIN_BY_TEMPORARY_PASSWORD,
];
